import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../components/Loader';
import ProviderProfileForm from '../../auth/components/ProviderProfileForm';
import { AuthAPI } from '../../../api';

const ProviderAccountAdmin = ({uuid}) => {
  const [profile, setProfile] = useState();
  const [loading, setLoading] = useState(true);

  React.useEffect(()=>{
    const fetchProfile = async(uuid) => {
      const resp = await AuthAPI.adminGetProviderProfile(uuid);
      setProfile(resp.payload.profile);
      setLoading(false);
    };
    fetchProfile(uuid);
  }, [uuid]);

  if (!profile) return <Loader/>;
  return (
    <ProviderProfileForm
      loading={loading}
      profile={profile}
      isAdmin={true}
      setProfile={setProfile}
    />
  );
};

ProviderAccountAdmin.propTypes = {
  uuid: PropTypes.string.isRequired,
};

export default ProviderAccountAdmin;
